import { ISection } from '@sdk/contracts';
import { dateProvider } from '@utils';
import { Button, Flex } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  TableContentWrapper,
  TableContentItem,
  TableContentItemValue,
  TableContentItemTitle,
  TableTitleWrapper
} from './SectionSummaryTable.styles';

import { Icon } from '@/components/Icon';
import { UnsyncSectionConfirmation } from '@/components/Sections';
import { useMutateSection } from '@/store';

type Props = {
  section: ISection;
};

export const SectionSummaryTable: React.FC<Props> = ({ section }) => {
  const { t } = useTranslation('CourseTranslations');
  const { unsyncSection, isWorking } = useMutateSection();
  const [isUnsyncSectionModalOpen, setIsUnsyncSectionModalOpen] = useState(false);

  return (
    <>
      <UnsyncSectionConfirmation
        section={section}
        isModalOpen={isUnsyncSectionModalOpen}
        setIsModalOpen={setIsUnsyncSectionModalOpen}
        onUnsyncSection={() => unsyncSection(section._id)}
      />

      <Flex vertical gap={32}>
        <Flex vertical gap={8}>
          <TableTitleWrapper>{t('SELECTED_SECTION_INFO')}</TableTitleWrapper>

          <TableContentWrapper>
            <TableContentItem>
              <TableContentItemTitle>{t('SECTION')}</TableContentItemTitle>
              <TableContentItemValue>{section.name}</TableContentItemValue>
            </TableContentItem>

            <TableContentItem>
              <TableContentItemTitle>{t('LAST_UPDATE')}</TableContentItemTitle>
              <TableContentItemValue>
                {dateProvider.format(section.updatedAt, 'dd/MM/yyyy')}
              </TableContentItemValue>
            </TableContentItem>

            <TableContentItem>
              <TableContentItemTitle>{t('ACTION')}</TableContentItemTitle>
              <TableContentItemValue>
                <Button
                  type="text"
                  icon={<Icon i="IbmDataReplication" size={16} />}
                  onClick={() => setIsUnsyncSectionModalOpen(true)}
                  loading={isWorking}
                  danger
                  size="small"
                  style={{ padding: 0 }}>
                  {t('UNSYNC_SECTION')}
                </Button>
              </TableContentItemValue>
            </TableContentItem>
          </TableContentWrapper>
        </Flex>

        <Flex vertical gap={8} style={{ paddingBottom: 24 }}>
          <TableTitleWrapper>{t('SYNCED_WITH')}</TableTitleWrapper>
          <TableContentWrapper>
            <TableContentItem>
              <TableContentItemTitle>{t('COURSE')}</TableContentItemTitle>
              <TableContentItemValue>{section.parentCourse?.name}</TableContentItemValue>
            </TableContentItem>

            <TableContentItem>
              <TableContentItemTitle>{t('SECTION')}</TableContentItemTitle>
              <TableContentItemValue>{section.parentSection?.name}</TableContentItemValue>
            </TableContentItem>
          </TableContentWrapper>
        </Flex>
      </Flex>
    </>
  );
};
